module.exports = "<div class=\"c-basket__reservation-details\" ng-if=\"$ctrl.displayReference()\">\n    <span class=\"c-basket__reservation__reference\">Currently editing {{ $ctrl.displayReference() }}</span>\n    <span class=\"c-basket__reservation__dates\">{{ $ctrl.displayDates() }}</span>\n\n    <hr>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/editReservationDetails.html
// module id = 697
// module chunks = 0